import { render, staticRenderFns } from "./PacienteConsultas.vue?vue&type=template&id=4c77c763&"
import script from "./PacienteConsultas.vue?vue&type=script&lang=js&"
export * from "./PacienteConsultas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports